export default { // data

}
